/**
* used component must be declare validate methods
*
*/
export const miniFieldMixin = validateCallback => ({
  data: function() {
    return {
      //mező értékének tárolása, csak valid esetben megy tovább a szülőnek
      fieldValue$: ''
    }
  },
  props: [
    //kitöltöttségi szint
    'fillingLevel',
    //mező értéke valid eset vagy undefined
    'fieldValue'
  ],
  created() {
    //init fieldvalue
    this.fieldValue$ = this.fieldValue
  },
  computed: {
    //argumentumként használt callback által történő validáció
    fieldIsValid() {
      return validateCallback(this.fieldValue$)
    },
    //modelként használt változó
    inputValue: {
      get() {
        return this.fieldValue$
      },
      set(val) {
        this.fieldValue$ = val
        if(this.fieldIsValid) {
          this.$emit(`update:fieldValue`, val)
        } else {
          this.$emit(`update:fieldValue`, undefined)
        }
      }
    }
  },
  methods: {
    //kitöltöttségi érték küldése (minden esetben változás kell történjen: oldValue != newValue)
    changeFillingLevel(valid) {
      let level = this.fillingLevel
      //set level (csökkenti vagy növeli, attól függően hogy negatív vagy pozitív érték fele változott)
      if(valid) {
        //increment
        level++
      } else {
        //decrement
        level--
      }
      this.$emit(`update:fillingLevel`,level)
      this.valid = level
    }
  },
  watch: {
    //proxy ValidateState
    fieldIsValid: {
      handler: function (newVal, oldVal) {
        if(newVal != oldVal) {
          this.changeFillingLevel(newVal)
        }
      },
      // detect nested value changes inside Objects
      deep: true
    }
  }
})
